<div class="navbar p-0 pl-3 top-navbar">
    <div class="col-md-2 brand-logo npm"><img src="assets/images/logo.jpeg"></div>
    <!--<div class="col-md-2 brand-logo npm"><img src="assets/images/mpma.jpeg"></div>-->
    <div class="col-md-10 npm">
        <!-- <ul class="navbar-nav ml-auto ml-md-0 text-right pr-3 user-con">

            <li class="nav-item dropdown user-box ">
                <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false"> <span class="smt-avatar"> <img
                            src="assets/images/avatar-9.jpg" width="36" height="36"> </span>
                    <span class="user-name">User Name</span>
                </a>



                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
                    <a class="dropdown-item" href="changepassword.html"> <span class="la la-wrench smt-icon"
                            aria-hidden="true"></span> <span>Change Password</span> </a>
                    <a class="dropdown-item" href="login.html"> <span class="la la-sign-out smt-icon"
                            aria-hidden="true"></span> <span>Logout</span> </a>
                </div>

            </li>

        </ul> -->
    </div>
</div>
<!--Topbar End-->

<nav class="navbar navbar-expand-sm navbar-light bg-green p-0 text-center">
    <div class="collapse navbar-collapse pl-2 pt-1 pr-2 text-center" id="nav-content">
        <div class="col-md-4 text-center">
            <h6><strong><i class="la la-phone"></i> Office Number : Ms Chong - 076522288</strong></h6>
        </div>
        <div class="col-md-8 text-left">
            <h6><strong><i class="la la-envelope-o"></i> For any enquiries related to your purchases, please email our
                    customers service center @ Mychong@lsspi.com</strong></h6>
        </div>


    </div>
</nav>
<!--Navigation-->
<!-- <nav class="navbar navbar-expand-sm navbar-light bg-faded p-0">

    <div class="collapse navbar-collapse pl-2  pr-2" id="nav-content">
        <ul class="navbar-nav">

            <li class="nav-item">
                <a class="nav-link" href="dashboard.html"><i class="la la-dashboard"></i> Dashboard</a>
            </li>

            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" data-toggle="dropdown" id="Preview" href="#" role="button"
                    aria-haspopup="true" aria-expanded="false">
                    <i class="la la-money"></i> Manage Order</a>
                <div class="dropdown-menu" aria-labelledby="Preview">
                    <a class="dropdown-item" href="purchase-order.html"> <i class="la la-money"></i> Purchase
                        Order</a>
                </div>
            </li>






        </ul>
    </div> 

</nav>-->
<!--Navigation End-->


<div class="content-sec">
    <form #form="ngForm">
        <div class="col-md-12 p-0">
            <div class="card content-box mt-4">

                <!--<div class="card-header">
                    <h3><i class="la la-money"></i> Purchase Order
                        <div class="float-right">
                            <h6><strong> Contribution to MPMA Environment Fund : <span class="text-primary">RM
                                        {{totalDonations}}</span></strong></h6>
                        </div>
                        <div class="mr-4 float-right pull-sm-left">
                            <h6><strong> Boxes Sold : <span class="text-primary">{{totalBoxesSold}}</span></strong></h6>
                        </div>
                    </h3>

                </div>-->


                <div class="row justify-content-center mt-4">
                    <div class="col-sm-12 col-md-12 text-center">
                        <h5><strong>To serve you better, we have launched our new website with exciting offers and
                                promos.</strong></h5>
                        <br>
                        <h6><strong>We will be glad to have you visit our new website - <a href="https://scgm.my">Click
                                    here</a></strong>
                        </h6>
                    </div>
                </div>


            </div>
        </div>
    </form>

    <div class="col-md-12">
        <div class="text-center mt-3">
            Powered by : <a href="https://zastainfotek.com/" target="_blank">ZastaInfotek</a>
        </div>
    </div>
</div>

<ng-template #maskImage let-modal>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Image Preview</h5>
            <button type="button" class="close" (click)="modal.dismiss('Cross Click')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body text-center">
            <img [src]="selectedImage" class="img-responsive" style="width:100%; height:450px">
        </div>

    </div>
</ng-template>


<a target="_blank" style="display:none" #file></a>